<script setup>
import { ref, computed, watch } from 'vue';
import { Link, Head, usePage } from '@inertiajs/vue3'
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/vue'
import Paginator from 'primevue/paginator'
import moment from 'moment';

let eurFormatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const props = defineProps({ 
  user: Object,
  bidsPlaced: Array,
  groupedPermissions: Array
})

const profile = {
  name: props.user.full_name,
  backgroundImage:
    'https://images.unsplash.com/photo-1444628838545-ac4016a5418a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
}
const stats = [
  { name: 'Eerdere biedingen', value: props.bidsPlaced.length, icon: 'gavel' },
]
const tabs = ref([
  { name: 'Eerdere biedingen', href: '#', count: props.bidsPlaced.length, current: true },
])
const selectTab = (selectedTab) => {
  tabs.value.forEach(tab => {
    tab.current = (tab === selectedTab)
  })
}


function getRemainingTime(endDateTime) {
    const end = moment(endDateTime);

    const now = moment();

    const duration = moment.duration(end.diff(now));

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();

    if (days > 0) {
        return `${days}d` + (hours > 0 ? ` ${hours}h` : '') + (minutes > 0 ? ` ${minutes}m` : '');
    } else if (hours > 0) {
        return `${hours}h` + (minutes > 0 ? ` ${minutes}m` : '');
    } else if (minutes > 0) {
        return `${minutes}m`;
    } else {
        return 'Veiling afgelopen';
    }
}

function translatePermission(permission) {
    //remove everything before the -
    permission = permission.split('-').pop();

    switch (permission) {
        case 'store':
            return 'Aanmaken';
        case 'index':
            return 'Overzicht';
        case 'update':
            return 'Bewerken';
        case 'destroy':
            return 'Verwijderen';
        case 'show':
            return 'Bekijken';
        case 'map':
            return 'Kaart';
        case 'accept_login':
            return 'Inloggen accepteren';
        case 'accept':
            return 'Accepteren';
        case 'place_bid':
            return 'Bod plaatsen';
        case 'remove_bid':
            return 'Bod verwijderen';
        case 'place_comment':
            return 'Comment plaatsen';
        case 'edit_question':
            return 'Vragen aanpassen';
        case 'register':
            return 'Auto aanmelden';
        case 'fees':
            return 'Fees';
        case 'options':
            return 'Opties';
        case 'preferences':
            return 'Voorkeuren';
        case 'conditions':
            return 'Condities';
    }
}

const page = usePage();

const pageBids = computed(() => page.props.bidsPlaced);

const bids = ref(props.bidsPlaced);
const bidsPaginator = ref(null);
const paginatedBidsData = ref([]);

watch(pageBids, () => {
  bids.value = pageBids.value;
    //set paginator to page 1
    if (bidsPaginator.value) {
        bidsPaginator.value.changePage(0);
    }
})

watch(bids, () => {
    if (bidsPaginator.value) {
        bidsPaginator.value.changePage(0);
    }
    changeBidsPagination({ rows: 10, page: 0 });
});

function changeBidsPagination(pageState) {
    //get row count
    const rows = pageState.rows;
    //get page count
    const page = pageState.page;

    //calculate start index
    const startIndex = rows * page;
    //calculate end index
    const endIndex = startIndex + rows;
    //get the data for the current page

    paginatedBidsData.value = bids.value.slice(startIndex, endIndex);
}

changeBidsPagination({ rows: 10, page: 0 });
</script>

<template>
  <Head :title="'Gebruiker ' + profile.name + ' | Mijnautosnelweg'" />
  <Head title="Gebruiker | Mijnautosnelweg" />
  <div class="relative">
    <div class="absolute bottom-4 right-4 gap-4 flex">
    <Link :href="'/portal/gebruikers/' + user.id + '/edit'" type="button"
        class="inline-flex justify-center rounded-md bg-white px-2 md:px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 gap-x-2">
        <font-awesome-icon :icon="['far', 'pencil']" class="h-5 w-5 text-gray-400 shrink-0"/>
      <span class="hidden md:block">Aanpassen</span>
      </Link>
      <Link href="" type="button"
        class="inline-flex justify-center rounded-md bg-white px-2 md:px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 gap-x-2">
        <font-awesome-icon :icon="['far', 'trash-can']" class="h-5 w-5 text-gray-400 shrink-0"/>
      <span class="hidden md:block">Verwijderen</span>
      </Link>
      <!-- <Link href="" type="button"
        class="inline-flex justify-center rounded-md bg-white px-2 md:px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 gap-x-2">
        <font-awesome-icon :icon="['far', 'trash-can']" class="h-5 w-5 text-gray-400 shrink-0"/>
      <span class="hidden md:block">Impersonate</span>
      </Link>
      <button @click="" type="button"
        class="inline-flex justify-center rounded-md bg-white px-2 md:px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 gap-x-2">
        <font-awesome-icon :icon="['far', 'trash-can']" class="h-5 w-5 text-gray-400 shrink-0"/>
        <span class="hidden md:block">Uren bekijken</span>
      </button> -->
    </div>
    <img class="h-24 md:h-32 w-full object-cover lg:h-48" :src="profile.backgroundImage" alt="" />
  </div>
  <main class="px-4 sm:px-6 pb-6 space-y-8">
    <div class="-mt-20 sm:-mt-18 flex items-end space-x-5">
      <img class="h-24 w-24 sm:h-32 sm:w-32 md:h-40 md:w-40 rounded-full border-2 md:border-4 border-white z-50 object-cover" v-if="user.avatar"
        :src="'/storage/avatars/'+user.avatar" alt="" />
      <div class="flex flex-col flex-1 mt-24">
        <div>
          <nav class="sm:hidden" aria-label="Back">
            <a href="#" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 gap-x-1">
              <font-awesome-icon :icon="['fas', 'chevron-left']" class="h-3 w-3 text-gray-400 shrink-0" />
              Back
            </a>
          </nav>
          <nav class="hidden sm:flex" aria-label="Breadcrumb">
            <ol role="list" class="flex items-center space-x-4">
              <li>
                <div class="flex">
                  <Link href="/portal/dashboard" class="text-sm font-medium text-gray-500 hover:text-gray-700">Dashboard
                  </Link>
                </div>
              </li>
              <font-awesome-icon :icon="['fas', 'chevron-right']" class="h-3 w-3 text-gray-400 shrink-0" />
              <li>
                <div class="flex">
                  <Link href="/portal/gebruikers" class="text-sm font-medium text-gray-500 hover:text-gray-700">
                  Gebruikers
                  </Link>
                </div>
              </li>
              <font-awesome-icon :icon="['fas', 'chevron-right']" class="h-3 w-3 text-gray-400 shrink-0" />
              <li>
                <div class="flex items-center">
                  <Link href="#" class=" text-sm font-medium text-gray-900 hover:text-gray-700">
                  {{ profile.name }}</Link>
                </div>
              </li>
            </ol>
          </nav>
        </div>
        <div class="sm:flex sm:min-w-0 sm:flex-1 sm:items-center sm:space-x-6 sm:pb-1 mt-2">
          <h1 class="truncate text-2xl font-bold text-gray-900">{{ profile.name }}</h1>
        </div>
      </div>
    </div>
    <div class="mt-6 hidden min-w-0 flex-1 sm:block md:hidden">
      <h1 class="truncate text-2xl font-bold text-gray-900">{{ profile.name }}</h1>
    </div>
    <div class="mt-8 flex flex-col gap-6">
      <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <div v-for="item in stats" :key="item.id"
          class="relative overflow-hidden border rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
          <dt>
            <div class="absolute rounded-md bg-royalblue-500 p-3">
              <font-awesome-icon :icon="['far', item.icon]" class="h-6 w-6 text-white shrink-0" aria-hidden="true" />
            </div>
            <p class="ml-16 truncate text-sm font-medium text-gray-500">{{ item.name }}</p>
          </dt>
          <dd class="ml-16 flex items-center justify-between pb-6 sm:pb-7">
            <p class="text-2xl font-semibold text-gray-900">{{ item.value }}</p>
            <div class="absolute left-0 right-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
              <div class="text-sm">
                <a href="#" class="font-medium text-brightorange hover:text-brightorange"><span
                    class="sr-only"> {{ item.name }} stats</span></a>
              </div>
            </div>
          </dd>
        </div>
      </dl>
    </div>
    <div>
      <dt class="text-lg font-semibold leading-7 text-gray-900">Permissies</dt>
      <li class="flex flex-wrap gap-1.5 py-2 text-sm leading-6" v-for="(groupedPermission, index) in props.groupedPermissions">
        <div
          class="inline-flex items-center rounded-md bg-white text-sm font-semibold text-gray-900 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white w-32">
          <span class="truncate font-medium p-2"><strong>{{ index }}</strong></span>
        </div>
        <div  v-for="permission in groupedPermission.permissions" :key="permission.id"
          class="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
          <span class="truncate font-medium p-2">{{ translatePermission(permission.permission) }}</span>
        </div>
      </li>
    </div>
    <TabGroup>
      <div class="flex flex-row justify-between overflow-x-auto overflow-y-clip">
        <TabList class="-mb-px flex space-x-4" aria-label="Tabs">
          <Tab v-for="tab in tabs" :key="tab.name" href="#"
            :class="[tab.current ? 'border-brightorange text-brightorange' : 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700', 'flex whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium']"
            :aria-current="tab.current ? 'page' : undefined" @click.prevent="selectTab(tab)">
            {{ tab.name }}
            <span v-if="tab.count"
              :class="[tab.current ? 'bg-brightorange text-white' : 'bg-gray-100 text-gray-900', 'ml-3 hidden rounded-full py-0.5 px-2.5 text-xs font-medium lg:inline-block']">{{
              tab.count }}</span>
          </Tab>
        </TabList>
      </div>
      <TabPanels class="block overflow-x-auto overflow-y-clip sm:overflow-visible">
        <TabPanel class="space-y-8">
          <div class="space-y-8" v-if="bids.length > 0">
            <div class="mt-10 ring-1 ring-gray-300 mx-0 rounded-lg">
                <table class="min-w-full divide-y divide-gray-300 border-b">
                    <thead>
                        <tr>
                            <th scope="col"
                                class="hidden md:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                Kavelnummer
                            </th>
                            <th scope="col"
                                class="hidden sm:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                Loopt af over
                            </th>
                            <th scope="col"
                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                Kavel
                            </th>
                            <th scope="col"
                                class="table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                Geplaatst bod
                            </th>
                            <th scope="col"
                                class="hidden sm:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                Hoogste bod
                            </th>
                            <th scope="col"
                                class="hidden lg:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                Indicatieprijs
                            </th>
                            <th scope="col"
                                class="hidden lg:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                                Dealer
                            </th>
                        </tr>
                    </thead>
                    <tbody class="divide-y">
                        <tr v-for="bid in paginatedBidsData">
                            <td class="whitespace-nowrap hidden md:table-cell px-3 py-4 text-sm text-gray-500">
                                {{bid.lot_id}}
                            </td>
                            <td class="whitespace-nowrap hidden sm:table-cell px-3 py-4 text-sm text-gray-500">
                                {{getRemainingTime(bid.lot.auction_end_date)}}
                            </td>
                            <td class="whitespace-nowrap table-cell px-3 py-4 text-sm text-gray-500 max-w-32 sm:max-w-40 overflow-clip overflow-ellipsis">
                                {{bid.lot.make}} {{bid.lot.model}} {{bid.lot.construction_year}}
                            </td>
                            <td class="whitespace-nowrap table-cell px-3 py-4 text-sm text-red-500">
                                {{eurFormatter.format(bid.amount)}}</td>
                            <td class="whitespace-nowrap hidden sm:table-cell px-3 py-4 text-sm text-green-500">
                                {{eurFormatter.format(bid.lot.highest_bid)}} </td>
                            <td class="whitespace-nowrap hidden lg:table-cell px-3 py-4 text-sm text-gray-500">
                                {{eurFormatter.format(bid.lot.price_indication)}}
                            </td>
                            <td class="whitespace-nowrap hidden lg:table-cell px-3 py-4 text-sm text-gray-500">
                                {{ bid.user.company_name }}
                            </td>
                            <td
                                class="hidden lg:flex whitespace-nowrap py-4 pr-4 pl-3 text-right text-sm font-medium gap-1.5">
                                <Link :href="'/portal/kavel/'+bid.lot_id" class="text-royalblue-500 hover:text-royalblue-500/80 ml-auto">
                                Bekijk kavel</Link>
                            </td>
                            <td class="flex lg:hidden whitespace-nowrap py-4 text-sm gap-1.5 pr-3">
                                <Link :href="'/portal/kavel/'+bid.lot_id" class="text-royalblue-500 hover:text-royalblue-500/80 ml-auto">
                                  <font-awesome-icon :icon="['far', 'eye']" class="h-5 w-5 shrink-0"/>
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            <Paginator ref="bidsPaginator" v-if="bids.length > 10" @page="changeBidsPagination" :rows="10"
                :totalRecords="bids.length" :rowsPerPageOptions="[10, 20, 30]"></Paginator>
            </div>
          </div>
          <div v-else>
              <div class="flex flex-col items-center justify-center">
                  <font-awesome-icon :icon="['far', 'gavel']" class="h-12 w-12 text-gray-400 shrink-0"/>
                  <p class="mt-4 text-sm font-semibold text-gray-900">Geen biedingen gevonden</p>
              </div>
          </div>
        </TabPanel>
      </TabPanels>
    </TabGroup>
  </main>
</template>
